import { formatDate } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { MatPaginator, MatTable, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { EquipamentoSituacaoLabels, EquipamentoTipoLabels } from '@tivic-team/manager-ts/dist/grl';
import { Concessao } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao.entity';
import { VeiculoEquipamentoSituacaoLabels } from '@tivic-team/manager-ts/dist/mob/enums/veiculo-equipamento-situacao.enum';
import { ConcessaoVeiculoDTO } from 'app/model/dtos/mob/concessao-veiculo.dto';
import { VeiculoEquipamentoDTO } from 'app/model/dtos/mob/veiculo-equipamento.dto';
import { ConcessaoVeiculoSearch } from 'app/services/mob/concessao-veiculo.search';
import { ConcessaoVeiculoService } from 'app/services/mob/concessao-veiculo.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'grid-equipamento',
  templateUrl: './grid-equipamento.component.html',
  styleUrls: ['./grid-equipamento.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class GridEquipamentoComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatTable, { static: true }) dataTable: MatTable<ConcessaoVeiculoDTO>;

  @Output() onFind: EventEmitter<ConcessaoVeiculoSearch> = new EventEmitter();

  pageSize: number = 10;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['idEquipamento', 'nome', 'tipo', 'situacao', 'instalacao', 'dtInstalacao', 'dtDesinstalacao',
    'dtValidade', 'observacoes'];
  formGroup: FormGroup
  cdConcessaoVeiculo: number;
  concessao: Concessao;
  concessaoVeiculo: ConcessaoVeiculoDTO;

  constructor(
    private _concessaoVeiculoService: ConcessaoVeiculoService,
    private _control: ControlContainer,
    private _activatedRoute: ActivatedRoute,
    private _router: Router
  ) {
  }

  ngOnInit() {
    this.formGroup = this._control.control as FormGroup;
  }

  ngAfterViewInit() {
    this.cdConcessaoVeiculo = this._activatedRoute.snapshot.params['cdConcessaoVeiculo'];
    this.load();
  }

  async load() {
    if (this.cdConcessaoVeiculo > 0) {
      this._concessaoVeiculoService.getEquipamentosByConcessaoVeiculo(this.cdConcessaoVeiculo).then(r => {
        this.dataSource = new MatTableDataSource(r);
        this.dataSource.paginator = this.paginator;
      })
        .catch(e => console.error(e));
    }
  }

  rowEditClick($event) {
    this._router.navigate(['equipamento', $event.cdEquipamento], {
      relativeTo: this._activatedRoute,
    });

  }

  public getIdEquipamentoLabelFunction(column, register: VeiculoEquipamentoDTO) {
    if (register.equipamento && register.equipamento.idEquipamento) return register.equipamento.idEquipamento;

    return '';
  }

  public getNomeEquipamentoLabelFunction(column, register: VeiculoEquipamentoDTO) {
    if (register.equipamento && register.equipamento.nmEquipamento) return register.equipamento.nmEquipamento;

    return '';
  }

  public getSituacaoEquipamentoLabelFunction(column, register: VeiculoEquipamentoDTO) {
    if (register.equipamento.stEquipamento !== undefined) return EquipamentoSituacaoLabels.get(register.equipamento.stEquipamento);

    return '';
  }

  public getTipoEquipamentoLabelFunction(column, register: VeiculoEquipamentoDTO) {
    if (register.equipamento.tpEquipamento !== undefined) return EquipamentoTipoLabels.get(register.equipamento.tpEquipamento);

    return '';
  }

  public getSituacaoVeiculoEquipamentoLabelFunction(column, register: VeiculoEquipamentoDTO) {
    if (register.stInstalacao !== undefined) return VeiculoEquipamentoSituacaoLabels.get(register.stInstalacao);

    return '';
  }

  dateVencimentoLabelFunction(column, register: VeiculoEquipamentoDTO){
    if(register && register.equipamento && register.equipamento.dtFinal){
      let date = formatDate(register.equipamento.dtFinal, 'dd/MM/yyyy', 'pt-BR');
      return date;
    }
    return 'Não Informado';
  }
}
